/* Publish by EComposer at 2025-07-29 10:49:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ph9jf93lmxk"]=  window.__ectimmers["ecom-ph9jf93lmxk"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(t&&t.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ph9jf93lmxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph9jf93lmxk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8luqult7bw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8luqult7bw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rycfneaqyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rycfneaqyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91qfp2eyb0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91qfp2eyb0j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hxb0ralncr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hxb0ralncr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-naweerl39i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-naweerl39i', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u6qss7ncfa9"]=  window.__ectimmers["ecom-u6qss7ncfa9"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let t=this.$el;if(!t)return;function i(s){const n=s.getBoundingClientRect();return n.top>=0&&n.left>=0&&n.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&n.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let s=t.querySelector(".ecom-element.ecom-base-image"),n=t.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),n.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),n.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-u6qss7ncfa9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6qss7ncfa9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9m1grpjign9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m1grpjign9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}